import React, { FC, useEffect, useState } from "react";
import WithOutFormAutoComplete from "../../../components/WithoutControlAutoComplete";

import axios from "axios";
import { baseServiceUrl, urls } from "../../../environment";
import Sidebar from "../../../components/Sidebar";
import ScutinyQuestionAnswers from "./ScrutinyQuestionAnswers";
import toast from "react-hot-toast";
import AddRemarksModal from "./AddRemarksModal";
import useUserStore from "../../../stores/useUserStores";

type CreateScrutinyPageProps = {};
const CreateScrutinyPage: FC<CreateScrutinyPageProps> = (): JSX.Element => {
  const userDetails = useUserStore();
  const [side, setside] = useState<boolean>(false);
  const [openRemarksModal, setOpenRemarksModal] = useState<boolean>(false);
  const [QuestionAnswers, setQuestionAnswers] = useState<any>([]);

  const [selectedExamId, setSelectedExamId] = useState<number | null>(null);
  const [selectedAnswerForReview, setSelectedAnswerForReview] = useState<
    number | null
  >(-1);
  const [examResultDetails, setExamResultDetails] = useState<any | null>(null);

  // useEffect(() => {
  //   if (
  //     !selectedExamId ||
  //     !userDetails ||
  //     !userDetails?.userdetail ||
  //     !userDetails.userdetail?.id
  //   )
  //     return;
  //   (async () => {
  //     try {
  //       const response = await axios.post(
  //         baseServiceUrl + urls.examiniResult,
  //         {
  //           user_id: userDetails?.userdetail.id,
  //           exam_id: selectedExamId,
  //         },
  //         {
  //           headers: {
  //             Authorization: "Bearer " + userDetails.token,
  //           },
  //         }
  //       );
  //       setQuestionAnswers(response.data);
  //     } catch (error: any) {}
  //   })();
  // }, [selectedExamId, userDetails]);

  useEffect(() => {
    if (
      !selectedExamId ||
      !userDetails ||
      !userDetails?.userdetail ||
      !userDetails.userdetail?.id
    )
      return;
    (async () => {
      try {
        userDetails.setLoading(true);
        const response = await axios.post(
          baseServiceUrl + urls.examiniResultSummary,
          {
            exam_id: selectedExamId,
            user_id: Number(userDetails.userdetail?.id),
          },
          {
            headers: {
              Authorization: "Bearer " + userDetails.token,
            },
          }
        );
        setExamResultDetails(response.data);
      } catch (error: any) {
        toast.error(error?.response?.data?.message);
      } finally {
        userDetails.setLoading(false);
      }
    })();
  }, [selectedExamId, userDetails]);

  const handleOnChangeExams = (value: any) => {
    if (value && Number(value) > 0) {
      setSelectedExamId(value);
    } else {
      setSelectedExamId(null);
    }
  };
  const handleCloseRemarksModal = () => {
    setOpenRemarksModal(false);
  };

  const handleSide = () => {
    setside((prev) => !prev);
  };

  return (
    <div className=" h-full  overflow-y-auto bg-gray-50 min-h-[80vh] overflow-x-hidden   w-full px-1  ">
      <AddRemarksModal
        openModal={openRemarksModal}
        handleCloseModal={handleCloseRemarksModal}
      />
      <div>
        <div className=" flex">
          <div className="fixed top-0 left-0 lg:w-[280px]  min-h-[100vh]">
            <Sidebar side={side} handleside={handleSide} />
          </div>
          <div className="mt-1  ml-[290px] w-[100vw]">
            <p className="text-[35px] ml-5 font-semibold">Raise Objection </p>
            <div
              className="flex items-center justify-between p-2 px-3"
              key={Math.random()}
            >
              <WithOutFormAutoComplete
                // fieldLabel={"Complexity Level"}
                fieldName={"exams"}
                placeholder={"Select Exam"}
                // disabled={Number(self?.marks) > 0}

                keys={"exam_id"}
                // options={domainContext.complexity}
                options={userDetails?.resultOfExamPapers?.exam_list ?? []}
                menuLabel={"title"}
                width="100%"
                value={selectedExamId}
                onChangeFn={handleOnChangeExams}
              />
            </div>
            {examResultDetails ? (
              <div className="mt-1 md:ml-5">
                <div>
                  <ScutinyQuestionAnswers
                    userResult={[]}
                    examResultDetails={examResultDetails}
                    selectedAnswerForReview={selectedAnswerForReview}
                    setSelectedAnswerForReview={setSelectedAnswerForReview}
                    openRemarksModal={() => setOpenRemarksModal(true)}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateScrutinyPage;
